import { Controller } from "@hotwired/stimulus"

// Simple parallax scrolling effect
// Usage: data-controller="parallax" data-parallax-speed-value="0.5"
export default class extends Controller {
  static values = {
    speed: { type: Number, default: 0.5 }
  }

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.handleScroll() // Initial position
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const scrolled = window.pageYOffset
    const rect = this.element.getBoundingClientRect()
    const elementTop = rect.top + scrolled
    const windowHeight = window.innerHeight

    // Only apply parallax when element is in view
    if (scrolled + windowHeight > elementTop && scrolled < elementTop + rect.height) {
      const yPos = (scrolled - elementTop) * this.speedValue
      this.element.style.transform = `translateY(${yPos}px)`
    }
  }
}
